import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals.js";
import reduxStore from "./configureEnvStore.js";
import { TwilioRoomProvider } from "./providers/useTwilioRoomProvider.jsx";
ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={reduxStore}>
        <TwilioRoomProvider>
            <App />
        </TwilioRoomProvider>
    </Provider>
);

reportWebVitals();
